import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { useFilter } from "../../../../context/FilterContext";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerProjectList,
  POST_GetPerformaInvoiceList,
  POST_GetPerformaInvoiceSendEmailDetails,
  POST_PerformaInvoiceCancel,
  POST_PerformaInvoiceDownloadPDF,
  POST_PerformaInvoiceEmailSend,
  POST_PerformaInvoiceExport,
  POST_PerformaInvoicePrint,
  POST_PerformaInvoiceWhatsAppMessageSend,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import moment from "moment";
import {
  cleanCsvString,
  errorMessage,
  successMessage,
  validateEmail,
  warningMessage,
} from "../CommonFunctions";

const PerformaInvoice = () => {
  const { filter, updateFilter } = useFilter();

  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "proforma-invoice" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "proforma-invoice" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "proforma-invoice" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "proforma-invoice" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [performaInvoiceList, setPerformaInvoiceList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const invoiceStatusOptions = [
    { label: "All", value: -1 },
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Cancel", value: 0 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      PerformaInvoiceNo:
        filter && filter?.page == "proforma-invoice"
          ? filter?.PerformaInvoiceNo
          : "",
      InwardNo:
        filter && filter?.page == "proforma-invoice" ? filter?.InwardNo : "",
      FromDate:
        filter && filter?.page == "proforma-invoice"
          ? filter?.FromDate
          : new Date(),
      ToDate:
        filter && filter?.page == "proforma-invoice"
          ? filter?.ToDate
          : new Date(),
      CustomerIDEncrypted:
        filter && filter?.page == "proforma-invoice"
          ? filter?.CustomerIDEncrypted
          : "",
      CustomerName:
        filter && filter?.page == "proforma-invoice"
          ? filter?.CustomerName
          : "",
      CustomerProjectIDEncrypted:
        filter && filter?.page == "proforma-invoice"
          ? filter?.CustomerProjectIDEncrypted
          : "",
      TCNo: filter && filter?.page == "proforma-invoice" ? filter?.TCNo : "",
      InvoiceStatus:
        filter && filter?.page == "proforma-invoice"
          ? filter?.InvoiceStatus
          : -1,
      Status: filter && filter?.page == "proforma-invoice" ? filter?.Status : 1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      PerformaInvoiceNo,
      InwardNo,
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      TCNo,
      InvoiceStatus,
      Status,
    },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      PerformaInvoiceNo: "",
      InwardNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      TCNo: "",
      InvoiceStatus: -1,
      Status: 1,
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "proforma-invoice",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      PerformaInvoiceNo: PerformaInvoiceNo,
      InwardNo: InwardNo,
      TCNo: TCNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerName: CustomerName,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      InvoiceStatus: InvoiceStatus,
      Status: Status,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PerformaInvoiceNo: PerformaInvoiceNo,
      InwardNo: InwardNo,
      TCNo: TCNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      InvoiceStatus: InvoiceStatus,
      Status: Status,
    };

    await post(POST_GetPerformaInvoiceList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setPerformaInvoiceList(response?.List);
        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PerformaInvoiceNo: PerformaInvoiceNo,
      InwardNo: InwardNo,
      TCNo: TCNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      InvoiceStatus: InvoiceStatus,
      Status: Status,
    };
    post(POST_PerformaInvoiceExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerProjectDDL = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getCustomerProjectDDL(CustomerIDEncrypted);
    } else {
      setCustomerProjectOptions([]);
      formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
    }
  }, [CustomerIDEncrypted]);

  const [showCancelPerformaInvoiceModal, setShowCancelPerformaInvoiceModal] =
    useState(false);

  const validationSchemaCancelPerformaInvoice = Yup.object().shape({
    CancelReason: Yup.string()
      .trim()
      .required("Cancel Reason is required field"),
  });

  const formikCancelPerformaInvoice = useFormik({
    validationSchema: validationSchemaCancelPerformaInvoice,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCancelPerformaInvoice(values, formikHelpers),
    initialValues: {
      PerformaInvoiceIDEncrypted: "",
      PerformaInvoiceNo: "",
      CancelReason: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikCancelPerformaInvoice;

  const cancelPerformaInvoice = (performaInvoiceID, performaInvoiceNo) => {
    formikCancelPerformaInvoice.resetForm();
    formikCancelPerformaInvoice.setFieldValue(
      "PerformaInvoiceNo",
      performaInvoiceNo
    );
    formikCancelPerformaInvoice.setFieldValue(
      "PerformaInvoiceIDEncrypted",
      performaInvoiceID
    );
    setShowCancelPerformaInvoiceModal(true);
  };

  const handleValidSubmitCancelPerformaInvoice = (values) => {
    setIsLoading(true);
    post(POST_PerformaInvoiceCancel, {
      PerformaInvoiceIDEncrypted: values?.PerformaInvoiceIDEncrypted,
      CancelledReason: values?.CancelReason,
      ModifiedByIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          getData(currentPage, currentSizePerPage);
          setShowCancelPerformaInvoiceModal(false);
        } else {
          setIsLoading(false);
          errorMessage(response?.Message);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [
    showSendEmailPerformaInvoiceModal,
    setShowSendEmailPerformaInvoiceModal,
  ] = useState(false);
  const [emailContactPersonOptions, setEmailContactPersonOptions] = useState(
    []
  );

  const validationSchemaSendEmailPerformaInvoice = Yup.object().shape({});

  const formikSendEmailPerformaInvoice = useFormik({
    validationSchema: validationSchemaSendEmailPerformaInvoice,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendEmailPerformaInvoice(values, formikHelpers),
    initialValues: {
      PerformaInvoiceIDEncrypted: "",
      PerformaInvoiceNo: "",
      emailListOfProjectContactPerson: [],
      emailListOfAdditionalContactPerson: [],
      emailAdditionalEmailID: "",
      emailCustomerIDEncrypted: "",
      emailCustomerName: "",
      emailCustomerContactPersonIDEncrypted: "",
      emailContactPerson: "",
      emailDesignation: "",
      emailMobileNo: "",
      emailEmailID: "",
      emailContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      emailListOfProjectContactPerson,
      emailListOfAdditionalContactPerson,
      emailCustomerIDEncrypted,
      emailCustomerName,
      emailCustomerContactPersonIDEncrypted,
      emailContactPerson,
      emailDesignation,
      emailMobileNo,
      emailEmailID,
      emailContactPersonID,
    },
  } = formikSendEmailPerformaInvoice;

  const openSendEmailPerformaInvoiceDialog = async (
    performaInvoiceID,
    performaInvoiceNo
  ) => {
    formikSendEmailPerformaInvoice.resetForm();
    formikSendEmailPerformaInvoice.setFieldValue(
      "PerformaInvoiceNo",
      performaInvoiceNo
    );
    formikSendEmailPerformaInvoice.setFieldValue(
      "PerformaInvoiceIDEncrypted",
      performaInvoiceID
    );
    setIsLoading(true);
    await post(POST_GetPerformaInvoiceSendEmailDetails, {
      PerformaInvoiceIDEncrypted: performaInvoiceID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendEmailPerformaInvoice.setFieldValue(
            "emailListOfProjectContactPerson",
            response?.ListOfProjectContactPerson
          );
        }
        setShowSendEmailPerformaInvoiceModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadOptionsCustomer_email = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  useEffect(() => {
    if (emailCustomerIDEncrypted) {
      getCustomerContactPersonDDL_email(emailCustomerIDEncrypted);
    } else {
      setEmailContactPersonOptions([]);
      formikSendEmailPerformaInvoice.setFieldValue(
        "emailCustomerContactPersonIDEncrypted",
        ""
      );
      formikSendEmailPerformaInvoice.setFieldValue("emailContactPerson", "");
      formikSendEmailPerformaInvoice.setFieldValue("emailDesignation", "");
      formikSendEmailPerformaInvoice.setFieldValue("emailMobileNo", "");
      formikSendEmailPerformaInvoice.setFieldValue("emailEmailID", "");
      formikSendEmailPerformaInvoice.setFieldValue("emailContactPersonID", "");
    }
  }, [emailCustomerIDEncrypted]);

  const getCustomerContactPersonDDL_email = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmailContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
              Designation: item.Designation,
              ContactPersonID: item.ContactPersonID,
            }))
          );

          // setWhatsAppMessageContactPersonOptions(
          //   response?.ListOfContactPersons?.filter(
          //     (x) => x.MobileNo !== ""
          //   )?.map((item) => ({
          //     label: item.ContactPerson,
          //     value: item.CustomerContactPersonIDEncrypted,
          //     MobileNo: item.MobileNo,
          //     EmailID: item.EmailID,
          //     Designation: item.Designation,
          //   }))
          // );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  const addAdditionalContactPerson_email = () => {
    if (emailCustomerIDEncrypted && emailCustomerContactPersonIDEncrypted) {
      if (
        emailListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            emailCustomerContactPersonIDEncrypted
        )?.length == 0
      ) {
        formikSendEmailPerformaInvoice.setFieldValue(
          "emailListOfAdditionalContactPerson",
          [
            ...emailListOfAdditionalContactPerson,
            {
              IsSelected: true,
              CustomerName: emailCustomerName,
              CustomerContactPersonIDEncrypted:
                emailCustomerContactPersonIDEncrypted,
              ContactPerson: emailContactPerson,
              Designation: emailDesignation,
              MobileNo: emailMobileNo,
              EmailID: emailEmailID,
              ContactPersonID: emailContactPersonID,
            },
          ]
        );
        formikSendEmailPerformaInvoice.setFieldValue(
          "emailCustomerContactPersonIDEncrypted",
          ""
        );
        formikSendEmailPerformaInvoice.setFieldValue("emailContactPerson", "");
        formikSendEmailPerformaInvoice.setFieldValue("emailDesignation", "");
        formikSendEmailPerformaInvoice.setFieldValue("emailMobileNo", "");
        formikSendEmailPerformaInvoice.setFieldValue("emailEmailID", "");
        formikSendEmailPerformaInvoice.setFieldValue(
          "emailContactPersonID",
          ""
        );
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!emailCustomerIDEncrypted) {
        formikSendEmailPerformaInvoice.setFieldError(
          "emailCustomerIDEncrypted",
          "Customer is required field"
        );
        formikSendEmailPerformaInvoice.setFieldTouched(
          "emailCustomerIDEncrypted",
          true
        );
      }
      if (!emailCustomerContactPersonIDEncrypted) {
        formikSendEmailPerformaInvoice.setFieldError(
          "emailCustomerContactPersonIDEncrypted",
          "Contact Person is required field"
        );
        formikSendEmailPerformaInvoice.setFieldTouched(
          "emailCustomerContactPersonIDEncrypted",
          true
        );
      }
    }
  };

  const handleValidSubmitSendEmailPerformaInvoice = async (values) => {
    if (values?.PerformaInvoiceIDEncrypted) {
      let listOfAdditionalEmails = values?.emailAdditionalEmailID?.trim()
        ? cleanCsvString(values?.emailAdditionalEmailID)?.split(",")
        : [];
      if (
        values?.emailListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.emailListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        listOfAdditionalEmails?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional email to send!"
        );
      } else {
        if (
          listOfAdditionalEmails?.length > 0 &&
          listOfAdditionalEmails?.filter((x) => validateEmail(x) == null)
            ?.length > 0
        ) {
          formikSendEmailPerformaInvoice.setFieldError(
            "emailAdditionalEmailID",
            "Please check it contains invalid email address"
          );
          formikSendEmailPerformaInvoice.setFieldTouched(
            "emailAdditionalEmailID",
            true
          );
        } else {
          setIsLoading(true);

          let emailCsv = "";
          Promise.all(
            values?.emailListOfProjectContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            values?.emailListOfAdditionalContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            listOfAdditionalEmails?.map((email) => {
              emailCsv = emailCsv + email + ":::" + 0 + ", ";
            }),
            (emailCsv = cleanCsvString(emailCsv))
          );
          //console.log("emailCsv", emailCsv);
          // return;
          setIsLoading(true);
          await post(POST_PerformaInvoiceEmailSend, {
            PerformaInvoiceIDEncrypted: values?.PerformaInvoiceIDEncrypted,
            BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
            CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
            CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
            EmailIDs: emailCsv,
          })
            .then((response) => {
              if (response?.IsSuccess) {
                successMessage(response?.Message);
                setShowSendEmailPerformaInvoiceModal(false);
                getData(currentPage, currentSizePerPage);
              } else {
                errorMessage(response?.Message);
                setIsLoading(false);
              }
            })
            .catch((error) => {
              console.log(error);
              setIsLoading(false);
            });
        }
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  const downloadPerformaInvoicePDF = async (performaInvoiceID) => {
    setIsLoading(true);
    await post(POST_PerformaInvoiceDownloadPDF, {
      PerformaInvoiceIDEncrypted: performaInvoiceID,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      CopyType: 2, ///* 2 = Original */
    })
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const printPerformaInvoice = async (performaInvoiceID, copyType) => {
    setIsLoading(true);
    await post(POST_PerformaInvoicePrint, {
      PerformaInvoiceIDEncrypted: performaInvoiceID,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      CopyType: copyType, ///* 1 = Duplicate, 2 = Original */
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let iframe = document.getElementById("iFramePerformaInvoice");
          if (iframe) {
            iframe.setAttribute("srcDoc", response?.HTMLContents);
            setTimeout(() => {
              iframe.contentWindow.print();
            }, 300);
          }
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [
    showSendWhatsAppMessagePerformaInvoiceModal,
    setShowSendWhatsAppMessagePerformaInvoiceModal,
  ] = useState(false);

  const [
    whatsAppMessageContactPersonOptions,
    setWhatsAppMessageContactPersonOptions,
  ] = useState([]);

  const validationSchemaSendWhatsAppMessagePerformaInvoice = Yup.object().shape(
    {}
  );

  const formikSendWhatsAppMessagePerformaInvoice = useFormik({
    validationSchema: validationSchemaSendWhatsAppMessagePerformaInvoice,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendWhatsAppMessagePerformaInvoice(
        values,
        formikHelpers
      ),
    initialValues: {
      PerformaInvoiceIDEncrypted: "",
      PerformaInvoiceNo: "",
      WAPMemailListOfProjectContactPerson: [],
      WAPMemailListOfAdditionalContactPerson: [],
      WAPMemailAdditionalEmailID: "",
      WAPMemailCustomerIDEncrypted: "",
      WAPMemailCustomerName: "",
      WAPMemailCustomerContactPersonIDEncrypted: "",
      WAPMemailContactPerson: "",
      WAPMemailDesignation: "",
      WAPMemailMobileNo: "",
      WAPMemailEmailID: "",
      WAPMsscAdditionalMobileNo: "",
      WAPMemailContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      WAPMemailListOfProjectContactPerson,
      WAPMemailListOfAdditionalContactPerson,
      WAPMemailCustomerIDEncrypted,
      WAPMemailCustomerName,
      WAPMemailCustomerContactPersonIDEncrypted,
      WAPMemailContactPerson,
      WAPMemailDesignation,
      WAPMemailMobileNo,
      WAPMemailEmailID,
      WAPMsscAdditionalMobileNo,
      WAPMemailContactPersonID,
    },
  } = formikSendWhatsAppMessagePerformaInvoice;

  const handleValidSubmitSendWhatsAppMessagePerformaInvoice = async (
    values
  ) => {
    if (values?.PerformaInvoiceIDEncrypted) {
      let additionalMobileNumbers = values?.WAPMsscAdditionalMobileNo?.trim();

      if (values?.WAPMsscAdditionalMobileNo) {
        //const isValidFormat = /^[0-9]+(,[0-9]+)*$/.test(additionalMobileNumbers);
        const isValidFormat = /^(\d{10})(,\d{10})*$/.test(
          additionalMobileNumbers
        );
        if (!isValidFormat) {
          errorMessage(
            "Please enter valid 10-digit mobile numbers separated by commas."
          );
          return;
        }
      }
      // let listOfAdditionalMobileNo = values?.WAPMsscAdditionalMobileNo?.trim()
      //   ? cleanCsvString(values?.WAPMsscAdditionalMobileNo)?.split(",")
      //   : [];

      let listOfAdditionalMobileNo = additionalMobileNumbers
        ? cleanCsvString(additionalMobileNumbers)?.split(",")
        : [];

      if (
        values?.WAPMemailListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.WAPMemailListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        listOfAdditionalMobileNo?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional mobile no to send message!"
        );
      } else {
        setIsLoading(true);

        let MobileNoCsv = "";
        Promise.all(
          values?.WAPMemailListOfProjectContactPerson?.filter(
            (x) => x.IsSelected == true
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          values?.WAPMemailListOfAdditionalContactPerson?.filter(
            (x) => x.IsSelected == true
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          listOfAdditionalMobileNo?.map((mno) => {
            MobileNoCsv = MobileNoCsv + mno + ":::" + 0 + ", ";
          }),
          (MobileNoCsv = cleanCsvString(MobileNoCsv))
        );

        let payload = {
          BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
          CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
          PerformaInvoiceIDEncrypted: values?.PerformaInvoiceIDEncrypted,
          CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
          MobileNos: MobileNoCsv,
        };

        // setIsLoading(false);
        // console.log("payload", values?.WAPMsscAdditionalMobileNo);
        // return;

        await post(POST_PerformaInvoiceWhatsAppMessageSend, payload)
          .then((response) => {
            if (response?.IsSuccess) {
              successMessage(response?.Message);
              setShowSendWhatsAppMessagePerformaInvoiceModal(false);
              getData(currentPage, currentSizePerPage);
            } else {
              errorMessage(response?.Message);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  const addAdditionalContactPerson_WAPM = () => {
    if (
      WAPMemailCustomerIDEncrypted &&
      WAPMemailCustomerContactPersonIDEncrypted
    ) {
      if (
        WAPMemailListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            WAPMemailCustomerContactPersonIDEncrypted
        )?.length == 0
      ) {
        formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
          "WAPMemailListOfAdditionalContactPerson",
          [
            ...WAPMemailListOfAdditionalContactPerson,
            {
              IsSelected: true,
              CustomerName: WAPMemailCustomerName,
              CustomerContactPersonIDEncrypted:
                WAPMemailCustomerContactPersonIDEncrypted,
              ContactPerson: WAPMemailContactPerson,
              Designation: WAPMemailDesignation,
              MobileNo: WAPMemailMobileNo,
              EmailID: WAPMemailEmailID,
              ContactPersonID: WAPMemailContactPersonID,
            },
          ]
        );
        formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
          "WAPMemailCustomerContactPersonIDEncrypted",
          ""
        );
        formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
          "WAPMemailContactPerson",
          ""
        );
        formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
          "WAPMemailDesignation",
          ""
        );
        formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
          "WAPMemailMobileNo",
          ""
        );
        formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
          "WAPMemailEmailID",
          ""
        );
        formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
          "WAPMemailContactPersonID",
          ""
        );
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!WAPMemailCustomerIDEncrypted) {
        formikSendWhatsAppMessagePerformaInvoice.setFieldError(
          "WAPMemailCustomerIDEncrypted",
          "Customer is required field"
        );
        formikSendWhatsAppMessagePerformaInvoice.setFieldTouched(
          "WAPMemailCustomerIDEncrypted",
          true
        );
      }
      if (!WAPMemailCustomerContactPersonIDEncrypted) {
        formikSendWhatsAppMessagePerformaInvoice.setFieldError(
          "WAPMemailCustomerContactPersonIDEncrypted",
          "Contact Person is required field"
        );
        formikSendWhatsAppMessagePerformaInvoice.setFieldTouched(
          "WAPMemailCustomerContactPersonIDEncrypted",
          true
        );
      }
    }
  };

  useEffect(() => {
    if (WAPMemailCustomerIDEncrypted) {
      getCustomerContactPersonDDL_email(WAPMemailCustomerIDEncrypted);
    } else {
      setEmailContactPersonOptions([]);
      //setWhatsAppMessageContactPersonOptions([]);
      formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
        "WAPMemailCustomerContactPersonIDEncrypted",
        ""
      );
      formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
        "WAPMemailContactPerson",
        ""
      );
      formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
        "WAPMemailDesignation",
        ""
      );
      formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
        "WAPMemailMobileNo",
        ""
      );
      formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
        "WAPMemailEmailID",
        ""
      );
      formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
        "WAPMemailContactPersonID",
        ""
      );
    }
  }, [WAPMemailCustomerIDEncrypted]);

  const openPerformaInvoiceWhatsAppMessageDialog = async (
    performaInvoiceID,
    performaInvoiceNo
  ) => {
    formikSendWhatsAppMessagePerformaInvoice.resetForm();
    formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
      "PerformaInvoiceNo",
      performaInvoiceNo
    );
    formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
      "PerformaInvoiceIDEncrypted",
      performaInvoiceID
    );
    setIsLoading(true);
    await post(POST_GetPerformaInvoiceSendEmailDetails, {
      PerformaInvoiceIDEncrypted: performaInvoiceID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
            "WAPMemailListOfProjectContactPerson",
            //response?.ListOfProjectContactPerson
            response?.ListOfProjectContactPerson?.filter(
              (item) => item.MobileNo !== ""
            )?.map((x) => ({
              ...x,
              IsSelected: false,
            }))
          );
        }
        setShowSendWhatsAppMessagePerformaInvoiceModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Proforma Invoice</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i
                      className="fa fa-window-restore me-2"
                      aria-hidden="true"
                    ></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 51 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 51 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to="/add-proforma-invoice"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Proforma Invoice
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Proforma Invoice No"
                              name="PerformaInvoiceNo"
                              placeholder={"Search Proforma Invoice No"}
                              component={CustomInput}
                            />
                          </Col>

                          <Col lg={3}>
                            <label className="mb-1">
                              Proforma Invoice Date
                            </label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Project"
                              name="CustomerProjectIDEncrypted"
                              placeholder={"Select Project"}
                              options={customerProjectOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                              menuStyles={{
                                position: "absolute",
                                right: 0,
                              }}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search Inward No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search TC No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Invoice Status"
                              name="InvoiceStatus"
                              placeholder={"Select Invoice Status"}
                              options={invoiceStatusOptions}
                              component={CustomSelect}
                              isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Status"
                              name="Status"
                              placeholder={"Select Status"}
                              options={statusOptions}
                              component={CustomSelect}
                              isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                  {"  "} Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                {/* This is commented because of Email Configuration form has Is Email send option so if user tick that option then the email instant will be selected by user which data has been inserted.
                {AuthUser?.IsInvoiceEmailSetup == false && (
                  <div className="text-danger">
                    Note: In Application setup - Invoice Mail Setting is
                    pending. So user wan't be able to send emails.
                  </div>
                )} */}
                <div
                  id="PerformaInvoice-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="PerformaInvoice-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="7%" style={{ minWidth: "90px" }}></th>
                        <th
                          style={{
                            width: "9%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("PerformaInvoiceNo");
                          }}
                        >
                          Proforma No{" "}
                          <span className="ml-1">
                            {sortBy == "PerformaInvoiceNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "7%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("PerformaInvoiceDate");
                          }}
                        >
                          Proforma Date{" "}
                          <span className="ml-1">
                            {sortBy == "PerformaInvoiceDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardNo");
                          }}
                        >
                          Inward No{" "}
                          <span className="ml-1">
                            {sortBy == "InwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TCNo");
                          }}
                        >
                          TC No{" "}
                          <span className="ml-1">
                            {sortBy == "TCNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "14%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ContactPerson");
                          }}
                        >
                          Contact Person{" "}
                          <span className="ml-1">
                            {sortBy == "ContactPerson" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("NetAmount");
                          }}
                        >
                          Proforma Amount{" "}
                          <span className="ml-1">
                            {sortBy == "NetAmount" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "7%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ModeOfDispatch");
                          }}
                        >
                          Mode Of Dispatch{" "}
                          <span className="ml-1">
                            {sortBy == "ModeOfDispatch" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "5%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InvoiceStatus");
                          }}
                        >
                          Invoice Status{" "}
                          <span className="ml-1">
                            {sortBy == "InvoiceStatus" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CreatedBy");
                          }}
                        >
                          Created By{" "}
                          <span className="ml-1">
                            {sortBy == "CreatedBy" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "5%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("WhatsAppMessageSend");
                          }}
                        >
                          WhatsApp Send{" "}
                          <span className="ml-1">
                            {sortBy == "WhatsAppMessageSend" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        {AuthUser?.Permissions?.Email == 1 ? (
                          <th
                            style={{
                              width: "5%",
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            onClick={() => {
                              handleClickSorting("MailSent");
                            }}
                          >
                            Mail Send{" "}
                            <span className="ml-1">
                              {sortBy == "MailSent" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                        ) : (
                          ""
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {performaInvoiceList?.length > 0 ? (
                        performaInvoiceList?.map((item, indx) => (
                          <tr key={indx}>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item?.IsCancelled == false ? (
                                <>
                                  {AuthUser?.UserType !== 1 ||
                                  formsList?.filter(
                                    (x) => x?.FormID == 51 && x?.IsEdit
                                  )?.length > 0 ? (
                                    <Link
                                      to={`/edit-proforma-invoice/${window.btoa(
                                        item.PerformaInvoiceIDEncrypted
                                      )}`}
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    // title="Original Copy"
                                    title="Print"
                                    onClick={() => {
                                      printPerformaInvoice(
                                        item.PerformaInvoiceIDEncrypted,
                                        2
                                      );
                                    }}
                                  >
                                    {SVGICON.Printer}
                                  </Link>
                                  {/* <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Duplicate Copy"
                                    onClick={() => {
                                      printPerformaInvoice(
                                        item.PerformaInvoiceIDEncrypted,
                                        1
                                      );
                                    }}
                                  >
                                    {SVGICON.Printer}
                                  </Link> */}
                                  {AuthUser?.Permissions?.Email == 1 ? (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Send Email"
                                      onClick={() => {
                                        openSendEmailPerformaInvoiceDialog(
                                          item.PerformaInvoiceIDEncrypted,
                                          item.PerformaInvoiceNo
                                        );
                                      }}
                                    >
                                      {SVGICON.SendEmail}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Export PDF"
                                    onClick={() => {
                                      downloadPerformaInvoicePDF(
                                        item.PerformaInvoiceIDEncrypted
                                      );
                                    }}
                                  >
                                    {SVGICON.PDF}
                                  </Link>
                                  {AuthUser?.UserType == 1 &&
                                  AuthUser?.Permissions?.Whatsup == 1 &&
                                  formsList?.filter(
                                    (x) =>
                                      x?.FormID == 81 && (x?.IsAdd || x?.IsEdit)
                                  )?.length > 0 ? (
                                    <>
                                      <Link
                                        className="icon-box icon-box-md me-1"
                                        title="Send Invoice in WhatsApp"
                                        onClick={() => {
                                          openPerformaInvoiceWhatsAppMessageDialog(
                                            item.PerformaInvoiceIDEncrypted,
                                            item.PerformaInvoiceNo
                                          );
                                        }}
                                      >
                                        {SVGICON.WhatsApp}
                                      </Link>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  {(AuthUser?.UserType !== 1 ||
                                    formsList?.filter(
                                      (x) => x?.FormID == 51 && x?.IsDelete
                                    )?.length > 0) &&
                                  item?.InvoiceStatus == false ? (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Cancel"
                                      onClick={() => {
                                        cancelPerformaInvoice(
                                          item.PerformaInvoiceIDEncrypted,
                                          item.PerformaInvoiceNo
                                        );
                                      }}
                                    >
                                      {SVGICON.Cancel}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                <span className="text-danger fs-12">
                                  Cancelled&nbsp;
                                  <OverlayTrigger
                                    trigger={["hover", "focus"]}
                                    responsive={true}
                                    overlay={
                                      <Tooltip className="toltip-popover">
                                        <strong className="p-1">
                                          {item.CancelledReason}
                                        </strong>
                                      </Tooltip>
                                    }
                                  >
                                    <span>
                                      <i
                                        className="fa fa-info-circle"
                                        style={{
                                          cursor: "pointer",
                                          color: "#9698ab",
                                        }}
                                      ></i>
                                    </span>
                                  </OverlayTrigger>
                                </span>
                              )}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.PerformaInvoiceNo}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.PerformaInvoiceDate}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.InwardNo}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.TCNo}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.BillingCustomerName}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.ContactPerson}{" "}
                              {item.MobileNo ? (
                                <>
                                  <br></br>
                                  {item.MobileNo}
                                </>
                              ) : (
                                ""
                              )}
                              {item.EmailID ? (
                                <>
                                  <br></br>
                                  {item.EmailID}
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "right",
                                verticalAlign: "top",
                              }}
                            >
                              {item.NetAmount}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.ModeOfDispatchName}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.InvoiceStatus == true ? "Yes" : "No"}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.CreatedBy}
                            </td>
                            <td
                              style={{
                                verticalAlign: "top",
                                textAlign: "left",
                              }}
                            >
                              {item.WhatsAppMessageSend == true ? (
                                <>
                                  Yes <br></br>
                                  {item.WhatsAppMessageSendBy}
                                  <br></br>
                                  {item.WhatsAppMessageSendDate}
                                </>
                              ) : (
                                "No"
                              )}
                            </td>
                            {AuthUser?.Permissions?.Email == 1 ? (
                              <td
                                style={{
                                  verticalAlign: "top",
                                  textAlign: "left",
                                }}
                              >
                                {item.MailSent == true ? (
                                  <>
                                    Yes <br></br>
                                    {item.MailSentBy}
                                    <br></br>
                                    {item.MailSentDate}
                                  </>
                                ) : (
                                  "No"
                                )}
                              </td>
                            ) : (
                              ""
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={13} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <hr className="mt-0 mb-0"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showCancelPerformaInvoiceModal}
            onHide={setShowCancelPerformaInvoiceModal}
            size="lg"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikCancelPerformaInvoice}>
                <Form onSubmit={formikCancelPerformaInvoice.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Cancel Proforma Invoice -{" "}
                      {formikCancelPerformaInvoice.values.PerformaInvoiceNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowCancelPerformaInvoiceModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row className="ps-2 pe-2">
                      <Col lg={12}>
                        <Field
                          label="Cancel Reason"
                          name="CancelReason"
                          placeholder={"Cancel Reason"}
                          component={CustomInput}
                          maxLength={500}
                          required
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowCancelPerformaInvoiceModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={showSendEmailPerformaInvoiceModal}
            onHide={setShowSendEmailPerformaInvoiceModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSendEmailPerformaInvoice}>
                <Form onSubmit={formikSendEmailPerformaInvoice.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Proforma Invoice Email -{" "}
                      {formikSendEmailPerformaInvoice.values.PerformaInvoiceNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() =>
                        setShowSendEmailPerformaInvoiceModal(false)
                      }
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Project Biling Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="ProjectBilingContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ProjectBilingContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "22%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "16%" }}>Designation</th>
                              <th style={{ width: "16%" }}>Mobile No</th>
                              <th style={{ width: "20%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {emailListOfProjectContactPerson?.length > 0 ? (
                              emailListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendEmailPerformaInvoice.setFieldValue(
                                            `emailListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Customer"
                          name="emailCustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          loadOptionsFn={loadOptionsCustomer_email}
                          component={CustomSelectAsync}
                          title={emailCustomerName}
                          labelFieldName="emailCustomerName"
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="emailCustomerContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={emailContactPersonOptions}
                          component={CustomSelect}
                          menuPosition="fixed"
                          onChange={(e) => {
                            formikSendEmailPerformaInvoice.setFieldValue(
                              "emailCustomerContactPersonIDEncrypted",
                              e?.value ?? ""
                            );
                            formikSendEmailPerformaInvoice.setFieldValue(
                              "emailContactPerson",
                              e?.label ?? ""
                            );
                            formikSendEmailPerformaInvoice.setFieldValue(
                              "emailDesignation",
                              e?.Designation ?? ""
                            );
                            formikSendEmailPerformaInvoice.setFieldValue(
                              "emailMobileNo",
                              e?.MobileNo ?? ""
                            );
                            formikSendEmailPerformaInvoice.setFieldValue(
                              "emailEmailID",
                              e?.EmailID ?? ""
                            );
                            formikSendEmailPerformaInvoice.setFieldValue(
                              "emailContactPersonID",
                              e?.ContactPersonID ?? ""
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addAdditionalContactPerson_email();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="AdditionalContactPerson-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="AdditionalContactPerson-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "24%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {emailListOfAdditionalContactPerson?.length >
                                0 ? (
                                  emailListOfAdditionalContactPerson?.map(
                                    (item, idx) => (
                                      <tr>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="checkIsSelectedACP"
                                            checked={item?.IsSelected}
                                            onChange={() => {
                                              formikSendEmailPerformaInvoice.setFieldValue(
                                                `emailListOfAdditionalContactPerson[${idx}].IsSelected`,
                                                !item?.IsSelected
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          ></input>
                                        </td>
                                        <td>{item?.CustomerName}</td>
                                        <td>{item?.ContactPerson}</td>
                                        <td>{item?.Designation}</td>
                                        <td>{item?.MobileNo}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.EmailID}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <Field
                          label="Additional Email"
                          name="emailAdditionalEmailID"
                          placeholder={"Enter Additional Email"}
                          component={CustomInput}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-envelope"></i> Send Email
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() =>
                        setShowSendEmailPerformaInvoiceModal(false)
                      }
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={showSendWhatsAppMessagePerformaInvoiceModal}
            onHide={setShowSendWhatsAppMessagePerformaInvoiceModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSendWhatsAppMessagePerformaInvoice}>
                <Form
                  onSubmit={
                    formikSendWhatsAppMessagePerformaInvoice.handleSubmit
                  }
                >
                  <Modal.Header>
                    <Modal.Title>
                      Proforma Invoice Send WhatsApp Message -{" "}
                      {
                        formikSendWhatsAppMessagePerformaInvoice.values
                          .PerformaInvoiceNo
                      }
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() =>
                        setShowSendWhatsAppMessagePerformaInvoiceModal(false)
                      }
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Project Biling Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="ProjectBilingContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ProjectBilingContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "22%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "16%" }}>Designation</th>
                              <th style={{ width: "16%" }}>Mobile No</th>
                              <th style={{ width: "20%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {WAPMemailListOfProjectContactPerson?.length > 0 ? (
                              WAPMemailListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
                                            `WAPMemailListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Customer"
                          name="WAPMemailCustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          loadOptionsFn={loadOptionsCustomer_email}
                          component={CustomSelectAsync}
                          title={WAPMemailCustomerName}
                          labelFieldName="WAPMemailCustomerName"
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="WAPMemailCustomerContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={emailContactPersonOptions}
                          //options={whatsAppMessageContactPersonOptions}
                          component={CustomSelect}
                          menuPosition="fixed"
                          onChange={(e) => {
                            formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
                              "WAPMemailCustomerContactPersonIDEncrypted",
                              e?.value ?? ""
                            );
                            formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
                              "WAPMemailContactPerson",
                              e?.label ?? ""
                            );
                            formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
                              "WAPMemailDesignation",
                              e?.Designation ?? ""
                            );
                            formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
                              "WAPMemailMobileNo",
                              e?.MobileNo ?? ""
                            );
                            formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
                              "WAPMemailEmailID",
                              e?.EmailID ?? ""
                            );
                            formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
                              "WAPMemailContactPersonID",
                              e?.ContactPersonID ?? ""
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addAdditionalContactPerson_WAPM();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="AdditionalContactPerson-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="AdditionalContactPerson-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "24%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {WAPMemailListOfAdditionalContactPerson?.length >
                                0 ? (
                                  // WAPMemailListOfAdditionalContactPerson?.map(
                                  //   (item, idx) => (
                                  WAPMemailListOfAdditionalContactPerson?.filter(
                                    (x) => x.MobileNo !== ""
                                  ).map((item, idx) => (
                                    <tr>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="checkIsSelectedACP"
                                          checked={item?.IsSelected}
                                          onChange={() => {
                                            formikSendWhatsAppMessagePerformaInvoice.setFieldValue(
                                              `WAPMemailListOfAdditionalContactPerson[${idx}].IsSelected`,
                                              !item?.IsSelected
                                            );
                                          }}
                                          style={{ cursor: "pointer" }}
                                        ></input>
                                      </td>
                                      <td>{item?.CustomerName}</td>
                                      <td>{item?.ContactPerson}</td>
                                      <td>{item?.Designation}</td>
                                      <td>{item?.MobileNo}</td>
                                      <td style={{ textAlign: "left" }}>
                                        {item?.EmailID}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <Field
                          //type="number"
                          label="Additional Mobile No"
                          name="WAPMsscAdditionalMobileNo"
                          placeholder={
                            "Enter Additional Mobile No like 1234567890,0987654321"
                          }
                          component={CustomInput}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fab la-whatsapp me-2" /> Send Message
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() =>
                        setShowSendWhatsAppMessagePerformaInvoiceModal(false)
                      }
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>

      <div style={{ display: "none" }}>
        <iframe
          id={`iFramePerformaInvoice`}
          title="Proforma Invoice"
          width="100%"
          style={{ height: "100vh", display: "none" }}
          frameBorder="0"
          srcDoc=""
        ></iframe>
      </div>
    </>
  );
};

export default PerformaInvoice;
